<script setup lang="ts">

</script>

<template>
  <section class="block1">
    <div class="blockCenter">
      <div class="left">
        <img src="/img/about/block1-标准版.png" alt="" class="imgMain">
      </div>
      <div class="right">
        <img src="/img/about/block1-高级版.png" alt="" class="imgMain">
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
section.block1 {
  position: relative;
  z-index: 0;

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 50%;
    background: #D5D8F4;
    z-index: -1;
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 50%;
    background: #F0D0DE;
    z-index: -1;
  }

  .blockCenter {
    @include glx-center-block;
    height: 630px;

    display: flex;
    align-items: stretch;

    @mixin item() {
      > img.imgMain {
        object-fit: none;
        transition-duration: 0.3s;

        &:hover {
          cursor: pointer;

          transform: translateY(-20px);
        }
      }
    }

    > .left {
      flex-grow: 1;
      background: #D5D8F4;
      padding-top: 112px;
      padding-right: 12px;

      @include item();

    }

    > .right {
      flex-grow: 1;
      background: #F0D0DE;
      padding-top: 60px;
      padding-left: 12px;

      @include item();


    }
  }
}
</style>